// Wrapper component that shows desktop or mobile version based on screen size.
import ExamTimetableDesktop from './ExamTimetableDesktop';
import ExamTimetableMobile from './ExamTimetableMobile';

export default function ExamTimetable() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <ExamTimetableDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <ExamTimetableMobile />
      </div>
    </>
  );
}
